import React, { FC } from 'react'
import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'
import { Button } from '@mui/material'

import { StylesProps } from '../../../types/interface/styles.interface'
import vippsImageSvg from '../../../static/images/vipps/VippsBtnImage.svg'
import { redirect } from '@dg-util'

export const useVippsBtnStyles = makeStyles<StylesProps>()((theme: Theme, props) => ({
  // TODO: Due to Vipps Documentation
  vipps: {
    width: '230px',
    height: '48px',
    margin: `15px auto`,
    color: theme.palette.success.contrastText,
    // The URL must be quoted. Webpack inlined this SVG as a base64 data URI,
    // which happens to contain no characters special to CSS; Vite inlines SVG
    // as a `mini-svg-data-uri` that keeps the markup readable and therefore
    // contains single quotes. An *unquoted* CSS url() token may not contain a
    // quote character, so the whole declaration was being discarded and the
    // button rendered blank. mini-svg-data-uri uses single quotes precisely so
    // the value can be wrapped in double quotes.
    background: `url("${props.backgroundImage}") no-repeat left`,
    backgroundSize: 'cover',
  },
}))

interface BtnVipps {
  url: string
  disabled: boolean
}

const VippsBtn: FC<BtnVipps> = ({ url, disabled }) => {
  const { classes } = useVippsBtnStyles({ backgroundImage: vippsImageSvg })

  return (
    <Button
      data-testid='vipps-button'
      variant='contained'
      size='medium'
      disabled={disabled || !url}
      className={classes.vipps}
      fullWidth
      onClick={() => redirect(url)}
    />
  )
}

export default VippsBtn
